exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline {\r\n    display:inline;\r\n}\r\n\r\n.instruction {\r\n     font-weight: normal;\r\n    color:red;\r\n}\r\n\r\n.instruction-icon {\r\n    height: 20px;\r\n    width: 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/drug-lookup/drug-lookup.component.css
// module id = ../../../../../src/widgets/drug-lookup/drug-lookup.component.css
// module chunks = main